import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ProjectList } from './ProjectList';
import { PendingUsersBanner } from '../../components/PendingUsersBanner';

export function Dashboard() {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);
  const [maxZoom, setMaxZoom] = useState(() => {
    const saved = localStorage.getItem('documentViewer_maxZoom');
    return saved ? parseInt(saved, 10) : 2000;
  });

  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/admin/login');
    }
  }, [isAuthenticated, navigate]);

  const handleMaxZoomChange = (value: number) => {
    setMaxZoom(value);
    localStorage.setItem('documentViewer_maxZoom', value.toString());
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div style={{ fontFamily: 'system-ui' }}>
      <header style={{
        padding: '16px 24px',
        background: '#1a1a2e',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h1 style={{ margin: 0, fontSize: '20px' }}>ConstMGR Admin</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span>{user?.name}</span>
          <button
            onClick={() => setShowSettings(!showSettings)}
            style={{
              background: 'transparent',
              border: '1px solid #fff',
              color: '#fff',
              padding: '8px 16px',
              cursor: 'pointer',
              borderRadius: '4px'
            }}
          >
            Settings
          </button>
          <button
            onClick={logout}
            style={{
              background: 'transparent',
              border: '1px solid #fff',
              color: '#fff',
              padding: '8px 16px',
              cursor: 'pointer',
              borderRadius: '4px'
            }}
          >
            Logout
          </button>
        </div>
      </header>

      <PendingUsersBanner />

      {showSettings && (
        <div style={{
          padding: '16px 24px',
          background: '#f5f5f5',
          borderBottom: '1px solid #ddd'
        }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: '16px' }}>Document Viewer Settings</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <label style={{ fontSize: '14px' }}>Max Zoom:</label>
            <input
              type="range"
              min="500"
              max="5000"
              step="100"
              value={maxZoom}
              onChange={(e) => handleMaxZoomChange(parseInt(e.target.value))}
              style={{ width: '200px' }}
            />
            <span style={{ fontSize: '14px', minWidth: '60px' }}>{maxZoom}%</span>
          </div>
          <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0 0' }}>
            Maximum zoom level for document viewer (affects all users)
          </p>
        </div>
      )}

      <main style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        <ProjectList />
      </main>
    </div>
  );
}
